import { cn } from 'noddi-ui-common';
import { NoddiSelectableBox } from 'noddi-ui-web';
import type { ReactNode } from 'react';
import { toggleValue } from './requestOfferOptions';

type Props<T extends string | number> = {
  question: string;
  options: { value: T; label: ReactNode }[];
  selected: T[];
  onChange: (selected: T[]) => void;
  /** Short labels sit two per row from `sm` up. */
  compact?: boolean;
};

/** One question of the request flow answered by ticking any number of boxes. */
export const MultiSelectStep = <T extends string | number>({
  question,
  options,
  selected,
  onChange,
  compact
}: Props<T>) => (
  <div className='flex flex-col gap-2'>
    <p className='font-semibold'>{question}</p>
    <div className={cn('grid grid-cols-1 gap-1', compact && 'sm:grid-cols-2')}>
      {options.map(({ value, label }) => {
        const isSelected = selected.includes(value);
        return (
          <NoddiSelectableBox
            key={value}
            size={compact ? 'small' : undefined}
            aria-pressed={isSelected}
            isSelected={isSelected}
            setIsSelected={(next) => onChange(toggleValue(selected, value, next))}
          >
            {label}
          </NoddiSelectableBox>
        );
      })}
    </div>
  </div>
);
